import { Flex } from 'components';
import { IGenericModal, Modal } from 'components/Modal/Modal';
import { ColorPicker } from 'components/_form/ColorPicker/ColorPicker';
import { FieldLabel, TextField } from 'components/_form';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuditFormCodeBlock } from './AuditFormCodeBlock';

interface Props extends IGenericModal {
  codeId: string;
  colorCode: string;
  onSave: (values: { id_code: string; color_code: string }) => void;
}

export const EditAuditFormCodeModal: React.FC<Props> = ({
  isOpen,
  onCancelClick,
  codeId,
  colorCode,
  onSave
}) => {
  const { t } = useTranslation();
  const [draftCodeId, setDraftCodeId] = useState(codeId);
  const [draftColorCode, setDraftColorCode] = useState(colorCode);

  useEffect(() => {
    if (isOpen) {
      setDraftCodeId(codeId);
      setDraftColorCode(colorCode);
    }
  }, [isOpen, codeId, colorCode]);

  const handleSave = () => {
    onSave({
      id_code: draftCodeId.trim(),
      color_code: draftColorCode
    });
    onCancelClick();
  };

  return (
    <Modal
      isOpen={isOpen}
      onCancelClick={onCancelClick}
      headerTitle={t('administrationAuditsView.changeFormName')}
      mainButton={{
        action: handleSave,
        variant: 'eucalyptus',
        label: t('buttons.save')
      }}
      isSecondButtonVisible
      gridTemplateColumns="70%"
    >
      <Flex flexDirection="column" gap="10px">
        <Flex alignItems="center" flexDirection={['column', 'row']}>
          <Flex width={['100%', '30%']}>
            <FieldLabel>
              {t('administrationTasksView.clickToChooseColor')}
            </FieldLabel>
          </Flex>
          <Flex
            width={['100%', '70%']}
            gap="16px"
            alignItems="center"
            flexWrap="wrap"
          >
            <ColorPicker
              controlledDisplayColorPicker={draftColorCode}
              onChange={setDraftColorCode}
            />
            <AuditFormCodeBlock
              codeId={draftCodeId}
              colorCode={draftColorCode}
            />
          </Flex>
        </Flex>

        <Flex flexDirection={['column', 'row']} alignItems="center">
          <Flex width={['100%', '30%']}>
            <FieldLabel>{t('administrationTasksView.code')}</FieldLabel>
          </Flex>
          <Flex width={['100%', '70%']}>
            <TextField
              value={draftCodeId}
              onChange={(e) => setDraftCodeId(e.target.value)}
            />
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
};
